export default __webpack_public_path__ + "8075e321ae8d9e8ee1faae03f17b929f.svg";